export default {
  title: 'Billede til smart prisregel',
  select: {
    generate_title: 'Generér et billede med AI',
    generate_subtitle: 'Vi opretter et ud fra din smarte prisregel.',
    generate_cta: 'Generér',
    upload_link: 'eller upload fra din enhed',
    rate_limit_company: {
      title: 'Vi skal lige have et øjeblik',
      description: 'Din restaurant har genereret mange billeder i denne time. Prøv igen om {{time}}.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'Lige en kort pause',
      description: 'Det ser ud til, at du har prøvet denne regel flere gange i træk. Vi er klar igen om {{time}}.',
    },
  },
  generating: {
    title: 'Genererer dit billede…',
    progress: {
      cooking: 'Laver noget lækkert…',
      plating: 'Anretter…',
      finishing: 'Tilføjer de sidste detaljer…',
    },
  },
  preview: {
    alt: 'Genereret billede til smart prisregel',
    hint: 'Ikke helt rigtigt? Generér igen, eller fortsæt for at beskære billedet.',
    click_to_expand: 'Klik for at udvide',
    regenerate: 'Generér igen',
    continue: 'Fortsæt til redigering',
  },
  toasts: {
    upload_success: 'Billedet blev uploadet.',
    upload_failed: 'Billedet kunne ikke uploades.',
    delete_success: 'Billedet blev slettet.',
    delete_failed: 'Billedet kunne ikke slettes.',
    generate_success: 'Billedet blev genereret.',
    generate_failed: 'Billedgenereringen kunne ikke startes.',
    generate_timeout: 'Billedet genereres stadig. Det vises her, når det er klar.',
    rate_limit_company: 'Timegrænsen for billeder er nået for denne restaurant. Prøv igen om {{time}}.',
    rate_limit_smart_pricing_rule: 'Lidt for mange forsøg med denne regel lige nu – prøv igen om {{time}}.',
  },
  time: {
    seconds_one: '1 sekund',
    seconds_other: '{{count}} sekunder',
    minutes_one: '1 minut',
    minutes_other: '{{count}} minutter',
    hours_one: '1 time',
    hours_other: '{{count}} timer',
  },
};
